<template>
	<CookieInformationBlocker
		class="c-cookie-information-blocker-custom"
		v-bind="{ ...$props, wrapper: 'div' }"
	>
		<template #default>
			<slot></slot>
		</template>

		<template #blocker="{ requiredCategories, cookieInformation }">
			<div
				:class="[
					'w-full bg-secondary text-text overflow-hidden',
					'px-3xl py-2xl',
				]"
			>
				<BaseH2 class="mb-md">
					<SvgIconWarning
						class="inline-block baseline relative"
						style="width: 1em; aspect-ratio: 62 /56; top: -0.1em"
					/>
					<span v-text="'Indhold Blokeret'"></span>
				</BaseH2>

				<div class="s-rich-text s-rich-text--monotone">
					<p>
						Dette element kan ikke vises, da du ikke har givet
						accept til følgende typer af cookies:
					</p>

					<ul>
						<li
							v-for="consent in requiredCategories.filter(
								(e) => e.consentGiven
							)"
							:key="`consent-${consent.name}`"
							v-text="
								{
									statistic: 'Statistiske',
									functional: 'Funktionelle',
									marketing: 'Marketing',
								}[consent.name]
							"
						></li>
					</ul>

					<p>
						Du kan ændre dine indstillinger ved at klikke på knappen
						herunder.
					</p>
				</div>

				<BaseButton class="mt-2xl" @click="cookieInformation.show">
					Åben cookie-indstillinger
				</BaseButton>
			</div>
		</template>
	</CookieInformationBlocker>
</template>

<script>
import CookieInformationBlocker from '~/citi-baseline/components/CookieInformationBlocker';
import SvgIconWarning from '~/assets/svgs/icon-warning.svg?inline';

export default {
	name: 'CookieInformationBlockerCustom',
	components: { CookieInformationBlocker, SvgIconWarning },
	props: CookieInformationBlocker.props,
};
</script>
